module.exports = __webpack_public_path__ + "img/results.b1b573fb.png";